import React, { useMemo } from 'react';

import { CONTENTREPORTINGAPI_URL } from 'lib/shared/config/config';

import { TintinClient, TintinClientCreator } from './TintinClient';

export interface TintinClientProps {
  client: TintinClient;
}

export const withTintinClient = <P extends TintinClientProps>(Comp: React.ComponentType<P>) => {
  return (props: Omit<P, keyof TintinClientProps>) => {
    const client = useMemo(() => TintinClientCreator.create(CONTENTREPORTINGAPI_URL), []);
    return <Comp {...(props as P)} client={client} />;
  };
};
